/**
 * <s-mega-feature> — mega menu panel body that swaps its feature photo.
 *
 * Hovering or focusing a link with data-feature-key shows the photo whose
 * data-feature-image matches it (by setting data-active). The last shown photo
 * stays until another link is hovered.
 */
class SMegaFeature extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const show = (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-feature-key]') : null;
      if (!link || !this.contains(link)) return;
      this.#activate(link.dataset.featureKey);
    };
    this.addEventListener('pointerover', show, { signal });
    this.addEventListener('focusin', show, { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #activate(key) {
    const slides = this.querySelectorAll('[data-feature-image]');
    const match = Array.from(slides).find((slide) => slide.dataset.featureImage === key);
    if (!match) return;
    for (const slide of slides) slide.toggleAttribute('data-active', slide === match);
  }
}

if (!customElements.get('s-mega-feature')) customElements.define('s-mega-feature', SMegaFeature);
